export const ROOT = '/';
export const BACKTESTING = '/backtesting';
export const OVERVIEW = '/overview';
export const SUMMARY = '/summary';
export const FUNDS = '/funds';
export const BENCHMARKS = '/benchmarks';
export const JOBS = '/jobs';
export const PORTFOLIOS = '/portfolios';
export const MARKET_DATA = '/marketdata';
export const DASHBOARD = '/dashboard';

/** Metrics Routes */
export const METRICS = '/metrics';
export const METRICS_NEW_METRIC = '/metrics/new-metric';
export const METRICS_EDIT_METRIC = '/metrics/edit-metric/:id';

/** Var allocation routes */
export const VAR_REPORT_PAGE = '/reports/var';
export const VAR_REPORT = '/reports/var/var';
export const VAR_ALLOCATION = '/reports/var/var-allocation';

/** Reports creations and editing */
export const REPORTS = '/reports';
export const REPORTS_NEW_REPORT = '/reports/new-report';
export const REPORTS_EDIT_REPORT = '/reports/edit-report';
export const REPORTS_CONFIG_REPORT = '/reports/config-report';

/** SEC 18F  routes */
export const REPORTS_REPORT = '/reports/report';
export const REPORTS_SUMMARY = '/reports/summary';

/** CustomReport routes */
export const CUSTOM_REPORT = '/reports/custom';
export const CUSTOM_REPORTS_REPORT = '/reports/custom/report';
export const CUSTOM_REPORTS_SUMMARY = '/reports/custom/summary';

export const REPORTS_BACKTESTING = '/reports/backtesting';
export const PORTFOLIOS_FUNDS = '/portfolios/funds';
export const PORTFOLIOS_BENCHMARKS = '/portfolios/benchmarks';
export const PORTFOLIOS_MAPPINGS = '/portfolios/mappings';
export const SUPPORT = '/support';
export const SIGN_IN = '/sign-in';
export const REGISTER = '/register';
export const REGISTER_CONFIRMED = '/register-true';
export const REGISTER_UNCONFIRMED = '/register-false';
export const REDIRECT_ON_INVALID_AUTH = SIGN_IN;

export const LAUNCHPAD_URL = 'https://launchpad.financialriskanalytics.net/#/';
